import { groupListStore } from "Pages/Project/Groups/Stores/GroupsStore";

type GroupIdKey = keyof Pick<API_Group, "id" | "bidderGroupId">;

export type GroupType =
  | API_GROUP_TYPE
  | "ALL"
  | "FOR_RIGHTS"
  | "FOR_MAIL"
  | "PUBLIC_AND_ORGANISATION"
  | "FOR_RIGHTS_NO_ORG";

interface GroupListResult {
  groupList: API_Group[];
  idKey: GroupIdKey;
}

/**
 * Endpoint for groups returns groups and organisations (biddergroups) which are located in separate tables.
 * That's why "id" field for groups with type == ORGANISATION is invalid and for ORGANISATIONS we should use
 * field "biddergroupId"
 */
export const getGroupListByType = (groupType: GroupType): GroupListResult => {
  const groupMap: Record<string, { list: API_Group[]; idKey?: GroupIdKey }> = {
    SYSTEM: { list: groupListStore.systemGroups },
    PUBLIC: { list: groupListStore.publicGroups },
    PRIVATE: { list: groupListStore.privateGroups },
    ORGANISATION: { list: groupListStore.organisationsGroups, idKey: "bidderGroupId" },
    FOR_RIGHTS: { list: groupListStore.forRights },
    FOR_RIGHTS_NO_ORG: { list: groupListStore.groupsForAccessRights },
    FOR_MAIL: { list: groupListStore.forMailAndPlot },
    PUBLIC_AND_ORGANISATION: { list: groupListStore.publicAndOrganisation },
  };

  const entry = groupMap[groupType];
  if (entry) {
    return { groupList: entry.list, idKey: entry.idKey ?? "id" };
  }

  return { groupList: groupListStore.list, idKey: "id" };
};
